import { Component, OnInit, Input, OnChanges } from '@angular/core'; 
import {NgbActiveModal, NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mod-select-date',
  templateUrl: './mod-select-date.component.html',
  styleUrls: ['./mod-select-date.component.scss']
})
export class ModSelectDateComponent implements OnInit {
  date;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  ok() {
    this.activeModal.close(this.date);
  }

  cancel() {
    this.activeModal.dismiss();
  }

}
